import {removeRepresentativeNote} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {representativeKeys, representativeMutationKeys} from "../../../../../representative-keys";

export function removeRepresentativeNoteMutationOptions(representativeId: string) {
  return mutationOptions({
    mutationKey: representativeMutationKeys.removeRepresentativeNote,
    mutationFn: (noteId: number) => removeRepresentativeNote(representativeId, noteId),
    onSuccess: async (_result, _noteId, _onMutateResult, {client}) => {
      await client.invalidateQueries({queryKey: representativeKeys.detail(representativeId)});
    },
  });
}
